export const METHOD = {
  CARD: 'Card',
  BANK: 'Bank',
  PENDING_CARD: 'Pending Card',
  PENDING_BANK: 'Pending Bank',
};
